import { useState, useRef } from 'react';

const programs = [
  {
    id: 1,
    title: 'Amanecer Musical',
    time: '06:00 - 09:00',
    dj: 'DJ María González',
    description: 'Comienza tu día con los mejores éxitos para despertar con energía',
    image: 'https://public.readdy.ai/ai/img_res/bf532327aa8f026066dd1e715c888ed1.jpg'
  },
  {
    id: 2,
    title: 'Hits del Mediodía',
    time: '12:00 - 15:00',
    dj: 'DJ Carlos Méndez',
    description: 'Los éxitos más sonados del momento para acompañar tu tarde',
    image: 'https://readdy.ai/api/search-image?query=Male%20radio%20DJ%20in%20professional%20broadcasting%20studio%20during%20midday%2C%20bright%20natural%20lighting%2C%20modern%20audio%20equipment%20and%20mixing%20console%2C%20energetic%20atmosphere%2C%20contemporary%20radio%20station%20interior%2C%20professional%20photography%2C%20vibrant%20midday%20ambiance&width=400&height=300&seq=prog2&orientation=landscape'
  },
  {
    id: 3,
    title: 'Tarde de Clásicos',
    time: '16:00 - 19:00',
    dj: 'DJ Laura Ramírez',
    description: 'Un viaje nostálgico por los clásicos que marcaron generaciones',
    image: 'https://readdy.ai/api/search-image?query=Female%20radio%20host%20in%20elegant%20studio%20during%20afternoon%20hours%2C%20warm%20ambient%20lighting%2C%20vintage%20and%20modern%20audio%20equipment%20blend%2C%20cozy%20professional%20atmosphere%2C%20retro-modern%20radio%20station%20design%2C%20golden%20hour%20lighting%2C%20high%20quality%20broadcast%20setting&width=400&height=300&seq=prog3&orientation=landscape'
  },
  {
    id: 4,
    title: 'Noche de Éxitos',
    time: '20:00 - 23:00',
    dj: 'DJ Roberto Silva',
    description: 'La mejor música para cerrar tu día con estilo',
    image: 'https://readdy.ai/api/search-image?query=Male%20DJ%20in%20modern%20radio%20studio%20at%20night%2C%20dramatic%20blue%20and%20purple%20lighting%2C%20professional%20broadcasting%20equipment%2C%20nighttime%20atmosphere%2C%20contemporary%20studio%20design%2C%20moody%20evening%20ambiance%2C%20high-end%20audio%20setup%2C%20professional%20photography&width=400&height=300&seq=prog4&orientation=landscape'
  },
  {
    id: 5,
    title: 'Madrugada Hits',
    time: '00:00 - 05:00',
    dj: 'DJ Andrea Torres',
    description: 'Música continua para los noctámbulos y madrugadores',
    image: 'https://readdy.ai/api/search-image?query=Female%20radio%20DJ%20in%20dimly%20lit%20studio%20during%20late%20night%20hours%2C%20soft%20blue%20ambient%20lighting%2C%20professional%20audio%20equipment%2C%20peaceful%20nighttime%20atmosphere%2C%20modern%20broadcast%20studio%2C%20serene%20late-night%20setting%2C%20professional%20radio%20environment&width=400&height=300&seq=prog5&orientation=landscape'
  }
];

export default function ProgramSchedule() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const cardWidth = container.offsetWidth;
      const scrollAmount = direction === 'left' ? -cardWidth : cardWidth;
      
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      
      if (direction === 'left' && currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      } else if (direction === 'right' && currentIndex < programs.length - 1) {
        setCurrentIndex(currentIndex + 1);
      }
    }
  };

  return (
    <section id="schedule" className="py-16 sm:py-24 lg:py-32 bg-[#0a0a0a]">
      <div className="px-4 sm:px-8 lg:px-20">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#d4af37] mb-3 sm:mb-4 lg:mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            PROGRAMACIÓN
          </h2>
          <p className="text-white/80 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto px-4">
            Descubre nuestros programas y los DJs que te acompañan durante todo el día
          </p>
        </div>

        <div className="relative">
          {/* Navigation Buttons - Hidden on mobile */}
          <button
            onClick={() => scroll('left')}
            disabled={currentIndex === 0}
            className="hidden lg:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 z-10 w-12 h-12 items-center justify-center bg-[#d4af37] rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl text-black"></i>
          </button>

          <button
            onClick={() => scroll('right')}
            disabled={currentIndex === programs.length - 1}
            className="hidden lg:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 z-10 w-12 h-12 items-center justify-center bg-[#d4af37] rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl text-black"></i>
          </button>

          {/* Programs Container */}
          <div 
            ref={scrollContainerRef}
            className="flex gap-4 sm:gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-4"
          >
            {programs.map((program) => (
              <div
                key={program.id}
                className="flex-shrink-0 w-[85%] sm:w-[70%] md:w-[45%] lg:w-[30%] snap-center"
              >
                <div className="bg-[#1a1a1a] rounded-xl overflow-hidden border border-[#d4af37]/20 hover:border-[#d4af37] transition-all duration-300 group h-full">
                  <div className="relative h-40 sm:h-48 overflow-hidden">
                    <img
                      src={program.image}
                      alt={program.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] to-transparent"></div>
                  </div>
                  
                  <div className="p-4 sm:p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center">
                        <i className="ri-time-line text-[#d4af37] text-lg sm:text-xl"></i>
                      </div>
                      <span className="text-[#d4af37] font-semibold text-xs sm:text-sm">{program.time}</span>
                    </div>
                    
                    <h3 className="text-white text-lg sm:text-xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                      {program.title}
                    </h3>
                    
                    <p className="text-white/60 text-xs sm:text-sm mb-3 sm:mb-4">
                      {program.description}
                    </p>
                    
                    <div className="flex items-center gap-2 sm:gap-3 pt-3 sm:pt-4 border-t border-white/10">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[#d4af37]/20 rounded-full flex items-center justify-center">
                        <i className="ri-mic-line text-[#d4af37] text-sm sm:text-base"></i>
                      </div>
                      <span className="text-white/80 text-xs sm:text-sm font-medium">{program.dj}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Dots Indicator - Mobile only */}
          <div className="flex lg:hidden justify-center gap-2 mt-6">
            {programs.map((_, index) => (
              <button
                key={index}
                onClick={() => {
                  setCurrentIndex(index);
                  if (scrollContainerRef.current) {
                    const container = scrollContainerRef.current;
                    const cardWidth = container.offsetWidth;
                    container.scrollTo({ left: cardWidth * index, behavior: 'smooth' });
                  }
                }}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex ? 'bg-[#d4af37] w-6' : 'bg-white/30'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
